import { loadDatadog } from '../services/datadog'
import { loadIntercom } from '../services/intercom.js'
import { loadAxeptio } from '../services/axeptio'
import { extractSignInUsername } from '../services/signInUsername'

// Before any third-party SDK starts: they capture window.location.href, and the
// sign-in username (email or CPF) travels in the URL fragment.
extractSignInUsername()

const searchParams = new URLSearchParams(window.location.search)
const is2SVPushResponsePage = window.location.pathname.includes('/two_step_verification/push/response')

if (searchParams.get('no-cookies') !== 'true' && !is2SVPushResponsePage) {
  loadAxeptio()
}

loadIntercom()
loadDatadog()
